import * as api from '@/lti/api'
import { storeAllEntities } from '@/lti/store/helpers'

export default {
  state: {
    courses: {},
  },

  mutations: {
    SET_COURSE_EVENTS (state, { courseId, eventIds }) {
      const course = state.courses[courseId]

      if (course !== null) {
        course.events = eventIds
      }
    },
  },

  actions: {
    getCourse ({ commit }, { withEvents, withRegistrationPossibilities }) {
      const includes = []

      if (withEvents) {
        includes.push('events.groups')
      }

      if (withRegistrationPossibilities) {
        includes.push('events.registrationPossibilities')
      }

      return api.getCourse({ include: includes })
        .then(storeAllEntities(commit))
    },

    suggestCourse ({ commit, state }, { postData }) {
      return api.suggestCourse(postData)
    },

    suggestQuestion ({ commit, state }, { postData }) {
      return api.suggestQuestion(postData)
    },

    // attendance matrix overview
    getCourseMatrixLessons ({ commit, state }) {
      return api.getCourseMatrixLessons().then(storeAllEntities(commit))
    },
    getCourseMatrixStudents ({ commit, state }, { queryParams = null }) {
      return api.getCourseMatrixStudents(queryParams).then(storeAllEntities(commit))
    },

    getCourseMatrixLessonDetails ({ commit, state }, { queryParams = null }) {
      return api.getCourseMatrixLessonDetails(queryParams).then(storeAllEntities(commit))
    },
    getCourseMatrixLessonExport ({ commit, state }, { queryParams }) {
      return api.getCourseMatrixLessonsExport(queryParams)
    },

    // student attendance
    getCourseStudentAttendance ({ commit }, { courseId }) {
      return api.getCourseStudentAttendance(courseId)
        .then(storeAllEntities(commit))
    },
  },

  getters: {},
}
